import { trackMixpanelEvent } from '../utils/general';
import { SLACK_CLIENT_ID } from '../utils/consts';

export const TRANSLATION_KEY = 'STATIC.PAGES.AI_WATCHLIST';

export const HEARTBEAT_INTERVAL_MS = 30000;

export const TOAST_AUTO_CLOSE_MS = 4000;

export const MONITOR_VERDICT_EVENT = 'data-monitor-verdict';

export const PROMPT_MAX_LENGTH = 8000;

export const MONITOR_STATUS = {
    IDLE: 'idle',
    QUEUED: 'queued',
    RUNNING: 'running',
    PAUSED: 'paused',
};

export const VERDICT_TYPES = {
    REPORT: 'report',
    SUMMARY: 'summary',
    NO_VERDICT: 'no_verdict',
    ERROR: 'error',
};

export const SENTIMENTS = {
    HEADS_UP: 'heads_up',
    GOOD_NEWS: 'good_news',
    NEUTRAL: 'neutral',
    PROMPT_UNCLEAR: 'prompt_unclear',
};

export const METRIC_TONES = {
    GOOD: 'good',
    BAD: 'bad',
    NEUTRAL: 'neutral',
};

export const CARD_STATES = {
    PAUSED: 'paused',
    RUNNING: 'running',
    QUEUED: 'queued',
    BUSY: 'busy',
    VERDICT: 'verdict',
};

export const RUN_FINISH_REASONS = {
    STOP: 'stop',
    CANCELLED: 'cancelled',
    ERROR: 'error',
};

export const SCHEDULE_FREQUENCIES = {
    HOURLY: 'hourly',
    DAILY: 'daily',
    WEEKLY: 'weekly',
};

export const DEFAULT_SCHEDULE = {
    frequency: SCHEDULE_FREQUENCIES.DAILY,
    days: [1],
    hour: 7,
    minute: 0,
};

export const WEEK_DAY_NUMBERS = Array.from({ length: 7 }, (_, i) => i + 1);

export const STARTER_CARDS = [
    {
        id: 'installDrop',
        sentiment: SENTIMENTS.HEADS_UP,
        titleKey: `${TRANSLATION_KEY}.EMPTY_STATE.STARTERS.INSTALL_DROP_TITLE`,
        promptKey: `${TRANSLATION_KEY}.EMPTY_STATE.STARTERS.INSTALL_DROP_PROMPT`,
    },
    {
        id: 'bidChange',
        sentiment: SENTIMENTS.GOOD_NEWS,
        titleKey: `${TRANSLATION_KEY}.EMPTY_STATE.STARTERS.BID_CHANGE_TITLE`,
        promptKey: `${TRANSLATION_KEY}.EMPTY_STATE.STARTERS.BID_CHANGE_PROMPT`,
    },
    {
        id: 'creativeFatigue',
        sentiment: SENTIMENTS.HEADS_UP,
        titleKey: `${TRANSLATION_KEY}.EMPTY_STATE.STARTERS.CREATIVE_FATIGUE_TITLE`,
        promptKey: `${TRANSLATION_KEY}.EMPTY_STATE.STARTERS.CREATIVE_FATIGUE_PROMPT`,
    },
];

export const RUN_ERROR_TOAST_KEYS = {
    'Monitor is paused': `${TRANSLATION_KEY}.TOASTS.RUN_PAUSED`,
    'Monitor check already in progress': `${TRANSLATION_KEY}.TOASTS.RUN_IN_PROGRESS`,
};

export const MENU_ACTION_ICONS = {
    EDIT_PROMPT: 'pencil',
    SCHEDULE: 'clock',
    PAUSE: 'player-pause',
    RESUME: 'player-play',
    DISCONNECT_SLACK: 'unlink',
    REMOVE: 'trash',
};

export const SLACK_CONNECTED_PARAM = 'slack_connected';
export const SLACK_ERROR_PARAM = 'slack_error';
export const SLACK_AUTHORIZATION_NOT_COMPLETED = 'authorization_not_completed';

export const buildMonitorSlackAuthUrl = monitorId => {
    const params = new URLSearchParams({
        scope: 'chat:write,im:write,incoming-webhook,channels:read',
        client_id: SLACK_CLIENT_ID,
        redirect_uri: `${window.location.origin}/interactive-service/slack`,
        state: monitorId,
    });
    return `https://slack.com/oauth/v2/authorize?${params}`;
};

export const AI_WATCHLIST_EVENT_PREFIX = 'Watchlist';

export const WATCHLIST_EVENTS = {
    RUN_NOW: 'Run Now',
    RUN_ALL: 'Run All',
    OPEN_THREAD: 'Open Thread',
    ADD_MONITOR: 'Add Monitor',
    DELETE_MONITOR: 'Delete Monitor',
    PAUSE_MONITOR: 'Pause Monitor',
    RESUME_MONITOR: 'Resume Monitor',
    EDIT_PROMPT: 'Edit Prompt',
    CHANGE_SCHEDULE: 'Change Schedule',
    SUGGESTION_CLICK: 'Suggestion Click',
    SLACK_CLICKED: 'Slack Clicked',
    SLACK_CONNECTED: 'Slack Connected',
    SLACK_DISCONNECTED: 'Slack Disconnected',
};

export const trackWatchlistEvent = (eventName, params) =>
    trackMixpanelEvent(AI_WATCHLIST_EVENT_PREFIX, eventName, params);

// The strip's collapsed pills only open the cards, so they report the click with is_pill to stay separable.
export const trackStarterCardClick = ({ titleKey }, translate, params) =>
    trackWatchlistEvent(WATCHLIST_EVENTS.SUGGESTION_CLICK, { suggestionTitle: translate(titleKey), ...params });

// Shared by both starter surfaces (the empty-state cards and the examples strip), which differ only in layout.
export const pickStarterCard = (card, onPick, translate) => {
    trackStarterCardClick(card, translate);
    onPick(translate(card.promptKey));
};
